import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

const MieszkaniecWoda = props => {

    const { rozliczenieWodyWmAktOpub, setOpen, setZestaw } = props;

    const handlePrint = (r) => {
        if (r) {
            setZestaw(r);
            setOpen(true);
        } else {
            setZestaw(undefined);
            setOpen(false);
        }
    }

    const lista = rozliczenieWodyWmAktOpub?.map( (rozliczenie, i) => {

        return (
            <tr key={i}>
                <td>
                    {rozliczenie?.opis}
                </td>
                <td>
                    <FontAwesomeIcon 
                        icon={faPrint} 
                        onClick={()=>handlePrint(rozliczenie)}
                    />
                </td>
            </tr>
        )
    })

    return (
        <div className='tabele'>
            <h4>
                Rozliczenie Wody
            </h4>  
            <table className='woda'>
                <tbody>
                    {lista}
                </tbody>
            </table>
        </div> 
    )
}

export default MieszkaniecWoda;